export default __webpack_public_path__ + "static/media/24-icon-arrow-down.53ca81d1.svg";